import { ResourceRef } from '@angular/core';
import { ApiResponse } from './apiresponse.model';
import { RestApi } from '@core/api/rest.api';

interface HasId {
  id?: number;

  [key: string]: any;
}

export abstract class RestDatasource<T extends HasId> extends RestApi<T> {
  abstract data: ResourceRef<ApiResponse<T[]> | undefined>;

  override async create(value: Partial<T>) {
    const newRecord = await super.create(value);
    this.insertData(newRecord);
    return newRecord;
  }

  override async createMultipart(value: FormData) {
    const newRecord = await super.createMultipart(value);
    this.insertData(newRecord);
    return newRecord;
  }

  insertData(newRecord: T) {
    if (this.data) {
      this.data.update(old => {
        if (old) {
          const newData = [...old.data, newRecord];
          return { ...old, data: newData };
        }
        return old;
      });
    }
  }

  override async update(id: number, value: T) {
    const updatedRecord = await super.update(id, value);
    this.updateData(updatedRecord);
    return updatedRecord;
  }

  override async updateMultipart(id: number, value: FormData) {
    const updatedRecord = await super.updateMultipart(id, value);
    this.updateData(updatedRecord);
    return updatedRecord;
  }

  updateData(updatedRecord: T) {
    if (this.data && updatedRecord) {
      this.data.update(old => {
        if (old) {
          const newData = old.data.map(r =>
            r.id == updatedRecord.id ? updatedRecord : r
          );
          return { ...old, data: newData };
        }
        return old;
      });
    }
  }

  override async remove(id: number) {
    const deletedRecord = await super.remove(id);
    if (this.data) {
      this.data.update(old => {
        if (old) {
          const newData = old.data.filter(r => r.id != id);
          return { ...old, data: newData };
        }
        return old;
      });
    }
    return deletedRecord;
  }

  clear() {
    this.data.set(undefined);
  }
}
